module.exports = __webpack_public_path__ + "fonts/latobolditalic.f98d1804.ttf";